import { Button } from '@/components/ui/button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { formatCurrency } from '@/lib/formatters'
import type { PaymentPlan } from './checkoutData'

const WHOLE_DOLLARS = { minimumFractionDigits: 0, maximumFractionDigits: 0 }
const money = (amount: number) => formatCurrency(amount, WHOLE_DOLLARS)

/** The quote card's GEICO payment plans table, with a way to pick one. */
export function PaymentPlanPicker({
  plans,
  selected,
  onSelect,
}: {
  plans: PaymentPlan[]
  selected?: string
  onSelect: (title: string) => void
}) {
  return (
    <Table className="border-ink-200 mt-3 border-y text-xs">
      <TableHeader>
        <TableRow className="border-ink-100">
          <TableHead className="h-auto w-px px-0 py-1.5 text-xs" />
          <TableHead className="bg-brand-100 h-auto px-3 py-1.5 text-right text-xs">Down payment</TableHead>
          <TableHead className="h-auto px-0 py-1.5 text-right text-xs">Then</TableHead>
          <TableHead className="h-auto px-0 py-1.5 text-right text-xs">Total</TableHead>
          <TableHead className="h-auto w-px px-0 py-1.5 text-xs" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {plans.map((plan) => {
          const isSelected = plan.title === selected
          return (
            <TableRow key={plan.title} className="border-ink-100 hover:bg-transparent">
              <TableCell className="text-foreground w-px px-0 py-1.5 pr-6 font-semibold whitespace-nowrap">
                {plan.title}
              </TableCell>
              <TableCell className="bg-brand-100 text-foreground px-3 py-1.5 text-right font-semibold">
                {money(plan.dueToday)}
              </TableCell>
              <TableCell className="text-muted-foreground px-0 py-1.5 text-right">
                {plan.installments ? (
                  <>
                    <div>
                      {plan.installments.count} {plan.installments.count === 1 ? 'payment' : 'payments'} of
                    </div>
                    <div>{money(plan.installments.amount)}</div>
                  </>
                ) : (
                  '—'
                )}
              </TableCell>
              <TableCell className="text-foreground px-0 py-1.5 text-right">{money(plan.total)}</TableCell>
              <TableCell className="w-px py-1.5 pr-0 pl-6">
                <Button
                  size="sm"
                  variant={isSelected ? 'default' : 'outline'}
                  aria-pressed={isSelected}
                  onClick={() => onSelect(plan.title)}
                >
                  {isSelected ? 'Selected' : 'Select'}
                </Button>
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
